import React, { useState } from 'react';
import './../styles/App.css';
import PatientList from '../components/PatientList';
import CabinetSideBar from '../components/UI/SideBar/CabinetSideBar';
import Navbar from '../components/Navbar';
import MyModal from '../components/UI/MyModal/MyModal';

const Cabinet = () => {

    const [currentWard, setCurrentWard] = useState(1);

    return (
        <div className="cabinet">
            <Navbar />
            <div className="mainPage">
                <CabinetSideBar currentWard={currentWard} setCurrentWard={setCurrentWard} />
                <PatientList currentWard={currentWard} />
            </div>
        </div>
    );
};

export default Cabinet;
